import { Card, CardHeader, Grid, Pagination, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState, useMemo, memo } from "react";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import UsersApi from "Classes/API/UsersApi";
import { useNavigate } from "react-router-dom";
import Loader from "layouts/loader/loader";
import SearchFeedbackStatistics from "Classes/Models/Requests/Administration/Statistics/SearchFeedbackStatistics";
import ChartComponent from "./ChartComponent";
import AsyncSelect from "react-select/async";

const MemoizedChartComponent = memo(ChartComponent);
const AccountingSessionsStatistics = () => {
  const navigate = useNavigate();
  const initialToDate = new Date();
  initialToDate.setMonth(initialToDate.getMonth() - 1);
  const [Page, setPage] = useState(1);
  const [ToDate, setToDate] = useState(null); // One month ago
  const [FromDate, setFromDate] = useState(null); // Today's date
  const [session, setSession] = useState([]); // Today's date
  const [result, setResult] = useState(null);
  const [selectedValues, setSelectedValues] = useState([]);
  const [sessionNames, setSessionNames] = useState([]);
  const [numberOfAbsentSessions, setNumberOfAbsentSessions] = useState([]);
  const [numberOfAdmittedPatients, setNumberOfAdmittedPatients] = useState([]);
  const [numberOfExceptions, setNumberOfExceptions] = useState([]);
  const [sessionsCount, setSessionsCount] = useState([]);
  const [totalDiscountedPrice, setTotalDiscountedPrice] = useState([]);

  const [totalFinalPrice, setTotalFinalPrice] = useState([]);
  const [totalNumberOfAdmittedPatients, setTotalNumberOfAdmittedPatients] = useState(0);
  const [totalNumberOfExceptions, setTotalNumberOfExceptions] = useState(0);
  const [totalSessionsCount, setTotalSessionsCount] = useState(0);
  const [totalDiscountedPrices, setTotalDiscountedPrices] = useState(0);
  const [totalFinalPrices, setTotalFinalPrices] = useState(0);
  const [totalNumberOfAbsentSessionsCount, setTotalNumberOfAbsentSessionsCount] = useState(0);

  // const handleSelectChange = (event) => {
  //   const newSelectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
  //   setSelectedValues((prevSelectedOptions) => {
  //     // Merge the old and new selections without duplicates
  //     const mergedOptions = Array.from(new Set([...prevSelectedOptions, ...newSelectedOptions]));
  //     console.log("selectedOptions: ", mergedOptions);
  //     return mergedOptions;
  //   });
  // };
  const handleSelectChange = (selectedOptions) => {
    setSelectedValues(selectedOptions ? selectedOptions.map((option) => option.value) : []);
  };
  const loadSessionOptions = (inputValue, callback) => {
    // Filter sessions based on input
    const filtered = sessionsParentAndChilds
      .filter((session) => session.name.toLowerCase().includes(inputValue.toLowerCase()))
      .map((session) => ({
        value: session.id,
        label: session.name,
      }));

    callback(filtered);
  };

  const chartDataAbsentSessions = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Number Of Absent Sessions",
          data: numberOfAbsentSessions,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, numberOfAbsentSessions]
  );

  const chartDataAdmittedPatients = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Number Of Admitted Sessions",
          data: numberOfAdmittedPatients,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, numberOfAdmittedPatients]
  );

  const chartDataExceptions = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Number Of Exceptions",
          data: numberOfExceptions,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, numberOfExceptions]
  );

  const chartDataSessionsCount = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Sessions Count",
          data: sessionsCount,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, sessionsCount]
  );

  const chartDataDiscountedPrice = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Total Discounted Price",
          data: totalDiscountedPrice,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, totalDiscountedPrice]
  );

  const chartDataFinalPrice = useMemo(
    () => ({
      labels: sessionNames,
      datasets: [
        {
          label: "Total Final Price",
          data: totalFinalPrice,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [sessionNames, totalFinalPrice]
  );

  const [loading, setLoading] = useState(true);
  const [sessionsParentAndChilds, setSessionsParentAndChilds] = useState([]);
  let sessionNameValueMap = {};

  const [datas, setDatas] = useState([]);
  const [labels, setLabels] = useState([]);

  const GetOptions = (session) => {
    navigate("/AccountingSessions/Details", {
      state: {
        SearchSession: session,
      },
    });
  };

  useEffect(() => {
    // Fetch initial data
    onSubmit();
    getSessionsParentAndChilds();
  }, []);

  const getSessionsParentAndChilds = () => {
    UsersApi.getSessionsParentAndChilds().then((result) => {
      console.log("result.data: ", result.data);
      setSessionsParentAndChilds(result.data);
    });
  };

  const handleRemoveChip = (chipValue) => {
    // Remove the chip with the specified value
    setSelectedValues(selectedValues.filter((value) => value !== chipValue));
  };

  const onSubmit = (event) => {
    setLoading(true);
    if (event) {
      event.preventDefault();
    }

    let SearchFeedback = new SearchFeedbackStatistics();
    SearchFeedback.FromDate = FromDate;
    SearchFeedback.ToDate = ToDate;
    if (selectedValues.length > 0) {
      selectedValues.forEach((element) => {
        SearchFeedback.Session.push(
          sessionsParentAndChilds.filter((session) => session.id == element)[0]
        );
      });
    }

    SearchFeedback.pagingParams.pageNumber = Page;
    SearchFeedback.pagingParams.pageSize = 10;
    console.log("SearchFeedback: ", SearchFeedback);

    UsersApi.SearchAccountingSessionsStatistics(SearchFeedback).then((result) => {
      setLoading(false);
      if (result.status == "Success") {
        setResult(result);
        const consolidatedData = result.data.flat();
        // Extract session names

        const sessionName = consolidatedData.map((session) => session.sessionName);
        const numberOfAbsentSessionsCount = consolidatedData.map(
          (session) => session.numberOfAbsentSessions
        );
        const numberOfAdmittedPatients = consolidatedData.map(
          (session) => session.numberOfAdmittedPatients
        );
        const numberOfExceptions = consolidatedData.map((session) => session.numberOfExceptions);
        const sessionsCount = consolidatedData.map((session) => session.sessionsCount);
        const totalDiscountedPrice = consolidatedData.map(
          (session) => session.totalDiscountedPrice
        );
        const totalFinalPrice = consolidatedData.map((session) => session.totalFinalPrice);

        // Convert string values to numbers

        const numericValuesAbsentSessionsCount = numberOfAbsentSessionsCount.map((value) =>
          Number(value)
        );
        const numericValuesExceptions = numberOfExceptions.map((value) => Number(value));
        const numericValuesSessionsCount = sessionsCount.map((value) => Number(value));
        const numericValuesDiscountedPrice = totalDiscountedPrice.map((value) => Number(value));
        const numericValuesFinalPrice = totalFinalPrice.map((value) => Number(value));

        // Calculate totals
        const totalNumberOfAbsentSessionsCount = numericValuesAbsentSessionsCount
          .filter((value) => !isNaN(value))
          .reduce((acc, currentValue) => acc + currentValue, 0);

        setTotalNumberOfAbsentSessionsCount(totalNumberOfAbsentSessionsCount);

        const totalNumberOfExceptions = numericValuesExceptions
          .filter((value) => !isNaN(value))
          .reduce((acc, currentValue) => acc + currentValue, 0);
        setTotalNumberOfExceptions(totalNumberOfExceptions);

        const totalSessionsCount = numericValuesSessionsCount
          .filter((value) => !isNaN(value))
          .reduce((acc, currentValue) => acc + currentValue, 0);
        setTotalSessionsCount(totalSessionsCount);

        const totalDiscountedPrices = numericValuesDiscountedPrice
          .filter((value) => !isNaN(value))
          .reduce((acc, currentValue) => acc + currentValue, 0);
        setTotalDiscountedPrices(totalDiscountedPrices);

        const totalFinalPrices = numericValuesFinalPrice
          .filter((value) => !isNaN(value))
          .reduce((acc, currentValue) => acc + currentValue, 0);
        setTotalFinalPrices(totalFinalPrices);

        // Filter and sum numeric values for Admitted Patients
        const numericValuesAdmittedPatients = numberOfAdmittedPatients.map((value) => {
          const numericValue = Number(value);
          return isNaN(numericValue) ? 0 : numericValue;
        });
        const totalNumberOfAdmittedPatients = numericValuesAdmittedPatients.reduce(
          (acc, currentValue) => acc + currentValue,
          0
        );
        setTotalNumberOfAdmittedPatients(totalNumberOfAdmittedPatients);

        setSessionNames(sessionName);
        setNumberOfAbsentSessions(numberOfAbsentSessionsCount);
        setNumberOfAdmittedPatients(numberOfAdmittedPatients);
        setNumberOfExceptions(numberOfExceptions);
        setSessionsCount(sessionsCount);
        setTotalDiscountedPrice(totalDiscountedPrice);
        setTotalFinalPrice(totalFinalPrice);

        console.log(numberOfAdmittedPatients);
      }
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && <Loader />}
      {!loading && (
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0" }}>
                  <MDBox
                    pt={2}
                    px={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium">
                      Filter by
                    </MDTypography>
                    <div>
                      <button
                        style={{ backgroundColor: "#3560AD", borderColor: "#3560AD" }}
                        type="button"
                        className="btn btn-primary mt-2 mr-2"
                        onClick={() => onSubmit()}
                      >
                        Search
                      </button>
                    </div>
                  </MDBox>

                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-md-4">
                          <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            From Date:
                          </MDTypography>
                          <DateTimePicker onChange={(e) => setFromDate(e)} value={FromDate} />
                        </div>
                        <div className="col-md-4">
                          <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            To Date:
                          </MDTypography>
                          <DateTimePicker onChange={(e) => setToDate(e)} value={ToDate} />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                            Select Session:
                          </MDTypography>
                          <br></br>
                          <AsyncSelect
                            isMulti
                            isClearable
                            cacheOptions
                            defaultOptions={sessionsParentAndChilds.map((session) => ({
                              value: session.id,
                              label: session.name,
                            }))}
                            loadOptions={loadSessionOptions}
                            onChange={handleSelectChange}
                            value={sessionsParentAndChilds
                              .filter((session) => selectedValues.includes(session.id))
                              .map((session) => ({
                                value: session.id,
                                label: session.name,
                              }))}
                            placeholder="Search and select sessions..."
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </div>
                        {/* {selectedValues.map((value) => (
                          <div key={value} className="col-md-12">
                            <div key={value} className="selected-chip">
                              {
                                sessionsParentAndChilds.filter((session) => session.id == value)[0]
                                  .name
                              }
                              <span className="remove-chip" onClick={() => handleRemoveChip(value)}>
                                &times;
                              </span>
                            </div>
                          </div>
                        ))} */}
                      </div>
                    </div>
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div className="container" style={{ display: "flex", flexDirection: "column" }}>
            <div className="row">
              {[
                {
                  title: "Admitted Patients",
                  data: chartDataAdmittedPatients,
                  total: totalNumberOfAdmittedPatients + " Sessions",
                },
                {
                  title: "Absent Session",
                  data: chartDataAbsentSessions,
                  total: totalNumberOfAbsentSessionsCount + " Sessions",
                },
                {
                  title: "Exceptions",
                  data: chartDataExceptions,
                  total: totalNumberOfExceptions + " Sessions",
                },
                {
                  title: "Sessions Count",
                  data: chartDataSessionsCount,
                  total: totalSessionsCount + " Sessions",
                },
                {
                  title: "Discounted Price",
                  data: chartDataDiscountedPrice,
                  total: Number(totalDiscountedPrices).toFixed(1) + " EGP",
                },
                {
                  title: "Final Price",
                  data: chartDataFinalPrice,
                  total: Number(totalFinalPrices).toFixed(1) + " EGP",
                },
              ].map((chart, index) => (
                <div
                  key={index}
                  className="col-md-12 mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <CardHeader title={chart.title} />
                      <span className="text-success mx-4 my-4">Total: {chart.total}</span>
                    </div>
                    <MDBox mb={3}>
                      <MemoizedChartComponent chartData={chart.data} />
                    </MDBox>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default AccountingSessionsStatistics;
